import { Theme } from "common";

export const editProspectPageStyles = {
  root: {
    flexGrow: 1,
    paddingRight: "30px",
    paddingBottom: "24px",
  },
  paper: {
    padding: Theme.spacing(2),
    height: "100%",
  },
  customPadding: {
    paddingTop: "15px",
    "&& .MuiGrid-item": {
      overflowWrap: "break-word",
    },
  },
  customTopPadding: {
    paddingTop: "20px",
  },
  datePicker: {
    "&& .MuiFormControl-root": {
      marginTop: "0px",
    },
  },
};
